import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK, TRACK_DIFFICULTY_BLUE } from "../../../config/constants";

const Track11BBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track11BBlack" transform="translate(2194.000000, 456.000000)" className="track">
		<polyline
			id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			strokeWidth={tracksWidth} strokeLinecap="round"
			points="74.9458342 0.54911337 82.8638049 87.8995742 51 215"/>

		{/* Todo: Connector */}
		{/*<line*/}
		{/*	className="connector"*/}
		{/*	x1="51.0650924" y1="214.892044" x2="0" y2="394"*/}
		{/*	stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}*/}
		{/*	strokeWidth={tracksWidth}*/}
		{/*	strokeLinecap="round"*/}
		{/*/>*/}

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track11BBlack')}
			coords="60.949237, 67.478637"
			text="11B"
			textCoordsX="8.47509766"
			textCoordsY="21.8018868"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track11BBlack.propTypes = trackPropTypes;

export default Track11BBlack;
